import axiosClient from './axiosClient';

export const adminStaffService = {
    // =============================================================
    // 1. QUẢN LÝ ĐƠN HÀNG (ORDERS)
    // =============================================================
    getAllOrders: () => axiosClient.get(`/staff/orders?t=${new Date().getTime()}`),
    updateOrderStatus: (orderId, status) => axiosClient.put(`/staff/orders/${orderId}/status?status=${status}`),
    confirmOrderWithShipping: (id, dummyMethodId, shippingFee) => axiosClient.put(`/staff/orders/${id}/confirm?shippingFee=${shippingFee}`),
    getOrderDetail: (orderId) => axiosClient.get(`/staff/orders/${orderId}`),
    confirmOrderPayment: (orderId) => axiosClient.put(`/staff/orders/${orderId}/confirm-payment`),
    updateOrderPaymentStatus: (orderId, isPaid) => axiosClient.put(`/staff/orders/${orderId}/payment-status?isPaid=${isPaid}`),
    sendOrderStatusEmail: (orderId) => axiosClient.post(`/staff/orders/${orderId}/send-status-email`),
    updateOrderDeliveryInfo: (orderId, data) => axiosClient.put(`/staff/orders/${orderId}/delivery-info`, data),

    // =============================================================
    // 2. QUẢN LÝ SẢN PHẨM (ITEMS)
    // =============================================================
    getAllItems: () => axiosClient.get('/staff/items'),
    getItemDetail: (id) => axiosClient.get(`/staff/items/${id}`),
    createNewItem: (formData) => axiosClient.post('/staff/items', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updateItemFull: (id, formData) => axiosClient.put(`/staff/items/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updateItemPriority: (id, priority) => axiosClient.patch(`/staff/items/${id}/priority?priority=${priority}`),
    deleteItem: (id) => axiosClient.delete(`/staff/items/${id}`),
    toggleMainPage: (id) => axiosClient.patch(`/staff/items/${id}/toggle-main-page`),
    updateItemStatus: (id, status) => axiosClient.patch(`/staff/items/${id}/status?val=${status}`),

    // =============================================================
    // 3. QUẢN LÝ DANH MỤC MENU
    // =============================================================
    getAdminMenus: (timestamp = '') => axiosClient.get(`/admin/menus${timestamp ? `?_t=${timestamp}` : ''}`),
    createMenu: (data) => axiosClient.post('/admin/menus', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updateMenu: (id, data) => axiosClient.put(`/admin/menus/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    deleteMenu: (id) => axiosClient.delete(`/admin/menus/${id}`),
    reorderMenus: (data) => axiosClient.put('/admin/menus/reorder', data),
    toggleMenuMainPage: (id) => axiosClient.patch(`/admin/menus/${id}/toggle-main-page`),

    // =============================================================
    // 4. QUẢN LÝ THIẾT BỊ & THƯƠNG HIỆU
    // =============================================================
    getCategories: () => axiosClient.get('/public/categories'),
    getBrands: () => axiosClient.get('/public/brands'),
    createCategory: (data) => axiosClient.post('/staff/device-categories', data),
    updateCategory: (id, data) => axiosClient.put(`/staff/device-categories/${id}`, data),
    deleteCategory: (id) => axiosClient.delete(`/staff/device-categories/${id}`),
    createBrand: (formData) => axiosClient.post('/staff/brands', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updateBrand: (id, formData) => axiosClient.put(`/staff/brands/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    deleteBrand: (id) => axiosClient.delete(`/staff/brands/${id}`),

    // =============================================================
    // 5. QUẢN LÝ THUỘC TÍNH (SPECS, PURPOSES, SALES)
    // =============================================================
    getPurposes: (timestamp = '') => axiosClient.get(`/public/purposes${timestamp ? `?_t=${timestamp}` : ''}`),
    getSales: () => axiosClient.get('/public/sales'),
    getSpecsByCategory: (categoryId) => axiosClient.get(`/public/categories/${categoryId}/specs`),
    getSpecs: () => axiosClient.get('/public/specs'),
    createSpec: (data) => axiosClient.post('/staff/specs', data),
    updateSpec: (id, data) => axiosClient.put(`/staff/specs/${id}`, data),
    deleteSpec: (id) => axiosClient.delete(`/staff/specs/${id}`),
    reorderSpecs: (specIds) => axiosClient.put('/staff/specs/reorder', specIds),
    toggleSpecFilter: (id) => axiosClient.patch(`/staff/specs/${id}/toggle-filter`),
    createPurpose: (data) => axiosClient.post('/staff/purposes', data),
    updatePurpose: (id, data) => axiosClient.put(`/staff/purposes/${id}`, data),
    deletePurpose: (id) => axiosClient.delete(`/staff/purposes/${id}`),
    reorderPurposes: (purposeIds) => axiosClient.put('/staff/purposes/reorder', purposeIds),
    createSale: (data) => axiosClient.post('/staff/sales', data),
    updateSale: (id, data) => axiosClient.put(`/staff/sales/${id}`, data),
    deleteSale: (id) => axiosClient.delete(`/staff/sales/${id}`),

    // =============================================================
    // 6. QUẢN LÝ TÀI KHOẢN (ACCOUNTS)
    // =============================================================
    getAllAccounts: () => axiosClient.get('/admin/accounts'),
    getAccountDetail: (id) => axiosClient.get(`/admin/accounts/${id}`),
    updateAccount: (id, data) => axiosClient.put(`/admin/accounts/${id}`, data),
    resetAccountPassword: (id, newPassword) => axiosClient.put(`/admin/accounts/${id}/reset-password`, { newPassword }),
    toggleLockAccount: (id) => axiosClient.put(`/admin/accounts/${id}/toggle-lock`),
    changeAccountRole: (id, newRole) => axiosClient.put(`/admin/accounts/${id}/role`, { role: newRole }),

    // =============================================================
    // 7. QUẢN LÝ PHƯƠNG THỨC THANH TOÁN
    // =============================================================
    getAllPaymentMethods: () => axiosClient.get('/staff/payment-methods'),
    createPaymentMethod: (formData) => axiosClient.post('/staff/payment-methods', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updatePaymentMethod: (id, formData) => axiosClient.put(`/staff/payment-methods/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    deletePaymentMethod: (id) => axiosClient.delete(`/staff/payment-methods/${id}`),

    // =============================================================
    // 8. CẤU HÌNH PC BUILDER
    // =============================================================
    getAllPcComponents: () => axiosClient.get('/staff/pc-components'),
    createPcComponent: (data) => axiosClient.post('/staff/pc-components', data),
    updatePcComponent: (id, data) => axiosClient.put(`/staff/pc-components/${id}`, data),
    deletePcComponent: (id) => axiosClient.delete(`/staff/pc-components/${id}`),
    getAllCompatibilityGroups: () => axiosClient.get('/staff/compatibility-groups'),
    createCompatibilityGroup: (data) => axiosClient.post('/staff/compatibility-groups', data),
    updateCompatibilityGroup: (id, data) => axiosClient.put(`/staff/compatibility-groups/${id}`, data),
    deleteCompatibilityGroup: (id) => axiosClient.delete(`/staff/compatibility-groups/${id}`),

    // =============================================================
    // 9. THỐNG KÊ & HỆ THỐNG
    // =============================================================
    getTraffic: () => axiosClient.get(`/admin/traffic?t=${new Date().getTime()}`),
    updateSystemConfig: (data) => axiosClient.post('/admin/config', data),
    scanImages: () => axiosClient.get('/admin/system/cleanup-images/scan'),
    cleanupImages: () => axiosClient.post('/admin/system/cleanup-images'),
    convertWebpImages: () => axiosClient.post('/admin/system/convert-webp'),
    fixDatabaseImageLinks: async () => {
        const response = await axiosClient.post('/admin/system/fix-db-links');
        return response.data;
    },

    // =============================================================
    // 10. QUẢN LÝ NỘI DUNG (TIN TỨC, DANH MỤC TIN, QUẢNG CÁO)
    // =============================================================
    getAllNews: () => axiosClient.get('/staff/content/news'),
    getNewsDetail: (id) => axiosClient.get(`/staff/content/news/${id}`),
    createNews: (data) => axiosClient.post('/staff/content/news', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updateNews: (id, data) => axiosClient.put(`/staff/content/news/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    deleteNews: (id) => axiosClient.delete(`/staff/content/news/${id}`),
    getAllNewsCategories: () => axiosClient.get('/staff/content/news-categories'),
    createNewsCategory: (data) => axiosClient.post('/staff/content/news-categories', data),
    updateNewsCategory: (id, data) => axiosClient.put(`/staff/content/news-categories/${id}`, data),
    deleteNewsCategory: (id) => axiosClient.delete(`/staff/content/news-categories/${id}`),
    getAllAdvertises: () => axiosClient.get('/staff/content/advertises'),
    createAdvertise: (data) => axiosClient.post('/staff/content/advertises', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    updateAdvertise: (id, data) => axiosClient.put(`/staff/content/advertises/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
    deleteAdvertise: (id) => axiosClient.delete(`/staff/content/advertises/${id}`),
    reorderAdvertises: (ids) => axiosClient.put('/staff/content/advertises/reorder', ids),
    toggleAdvertiseStatus: (id) => axiosClient.patch(`/staff/content/advertises/${id}/toggle-status`),
    uploadEditorImage: (formData) => axiosClient.post('/staff/upload-editor-image', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
    uploadExternalEditorImage: async (url, folder) => {
        const response = await axiosClient.post('/staff/upload-external-image', { url, folder });
        return response;
    },

    // =============================================================
    // 11. NHẬT KÝ HOẠT ĐỘNG (ACTION LOGS)
    // =============================================================
    getActionLogs: (page = 0, size = 20) => axiosClient.get(`/admin/action-logs?page=${page}&size=${size}`),
};